import moment from 'moment';
import axiosConfig from './axiosConfig';
import { extractReportDownloadUrl } from '../utils/reportDownloadUrl';

const METRICS_EXCEL_TIMEOUT_MS = 5 * 60 * 1000;

const parseMetricsExcelPayload = (responseData) => {
  const payload = responseData?.data ?? responseData ?? {};
  const fileUrl = extractReportDownloadUrl(payload);
  const fileName = payload.fileName || payload.filename || '';
  const success = payload.success !== false && Boolean(fileUrl);

  return {
    success,
    fileUrl,
    fileName,
    projectId: payload.projectId,
    projectName: payload.projectName,
    fromDate: payload.fromDate,
    toDate: payload.toDate,
    dayCount: payload.dayCount,
    firstLogDate: payload.firstLogDate,
    lastLogDate: payload.lastLogDate,
    message: payload.message || payload.error,
  };
};

/**
 * Generate and fetch the project metrics Excel export (Daily, Safety, Mainline, Totals sheets).
 * Large date ranges can take several minutes — uses an extended request timeout.
 */
export const fetchProjectMetricsExcel = async ({
  projectId,
  toDate,
  fromDate,
} = {}) => {
  if (!projectId) {
    throw new Error('Project is required to export metrics.');
  }

  const params = {};
  if (toDate) {
    params.toDate = moment(toDate).format('YYYY-MM-DD');
  }
  if (fromDate) {
    params.fromDate = moment(fromDate).format('YYYY-MM-DD');
  }

  const response = await axiosConfig.get(
    `/project-status/projects/${projectId}/metrics-excel`,
    {
      params,
      timeout: METRICS_EXCEL_TIMEOUT_MS,
    }
  );

  const parsed = parseMetricsExcelPayload(response.data);
  if (!parsed.success) {
    throw new Error(parsed.message || 'Failed to generate project metrics Excel export.');
  }

  return parsed;
};
